import React from 'react';

interface StartStepProps {
  onProtocolSelect: (protocol: 'a2a' | 'ap2' | 'mcp') => void;
}

const StartStep: React.FC<StartStepProps> = ({ onProtocolSelect }) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="welcome-screen">
          <h2>Welcome to Channel Onboarding</h2>
          <p>
            You're about to configure a new channel based on a payload coming from an agent. 
            This wizard will guide you through capturing the payload, configuring the channel, 
            and finalizing the setup.
          </p>
          <p>
            <strong>First, please select the protocol type for your new channel:</strong>
          </p>

          <div className="protocol-selection">
            <button
              className="protocol-button"
              onClick={() => onProtocolSelect('a2a')}
            >
              <div className="protocol-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <div className="protocol-name">A2A / UCP</div>
              <div className="protocol-description">
                Agent-to-Agent protocol for direct communication between intelligent agents, including support for UCP extensions
              </div>
            </button>

            <button
              className="protocol-button"
              onClick={() => onProtocolSelect('ap2')}
            >
              <div className="protocol-icon">
                <i className="fas fa-layer-group"></i>
              </div>
              <div className="protocol-name">AP2</div>
              <div className="protocol-description">
              The Agent Payments Protocol (AP2) is an extension of A2A specifically designed to enable secure, auditable, and payment-agnostic financial transactions initiated by AI agents.
              </div>
            </button>

            <button
              className="protocol-button"
              onClick={() => onProtocolSelect('mcp')}
            >
              <div className="protocol-icon">
                <i className="fas fa-plug"></i>
              </div>
              <div className="protocol-name">MCP</div>
              <div className="protocol-description">
                Model Context Protocol for connecting AI models with external data sources
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartStep;
